// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQBlock_wrapper__2bggZ","title":"FAQBlock_title__rYq2m"};